import { useMessagePage } from './hook';
import { ChatBox } from '../CommunicationPage/components/ChatBoxTab/ChatBox';
import { Stack } from '@mui/material';
import React from 'react';

export const MessagePage = () => {
  const { fetchMoreChatDetail, handleDeleteMessage, onSendMessage, messageNotes, hasMoreMessage } =
    useMessagePage();
  return (
    <Stack width={'100%'}>
      <ChatBox
        isMobile
        notes={messageNotes}
        handleDeleteMessage={handleDeleteMessage}
        onSendMessage={onSendMessage}
        hasMoreMessage={hasMoreMessage}
        fetchMoreChatDetail={fetchMoreChatDetail}
      />
    </Stack>
  );
};
